import React from 'react';
import { AppBar, Toolbar, Typography, Box, useTheme } from '@mui/material';
import nextwaveLogo from '../../assets/images/Infinium.png';

const HeaderBar = () => {
    const theme = useTheme();

    return (
        <AppBar
            position="fixed"
            elevation={2}
            sx={{
                //backgroundColor: 'transparent',
                backgroundColor: '#ffffff',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'primary.main',   // ← no useTheme needed
                    WebkitMaskImage: 'linear-gradient(to right, black 0%, transparent 100%)',
                    maskImage: 'linear-gradient(to right, black 0%, transparent 100%)',
                    zIndex: 0,
                },
            }}
        >
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', py: 1, position: 'relative', zIndex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight={600}>
                        Quantexa Maturity Assessment
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={nextwaveLogo}
                        alt="Infinium"
                        height="45"
                        style={{ marginLeft: theme.spacing(2) }}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default HeaderBar;
